import { render, staticRenderFns } from "./CostiGAListTable.vue?vue&type=template&id=499c0986&"
import script from "./CostiGAListTable.vue?vue&type=script&lang=js&"
export * from "./CostiGAListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports